import { configureStore } from "@reduxjs/toolkit";
import bookReducer from "../src/slice/bookSlice";
import authorReducer from "../src/slice/authorSlice";
import ratingReducer from "../src/slice/ratingSlice";
import tvShowListReducer from "./slice/tvShowListsSlice";
import tvShowListItemReducer from "./slice/tvShowListItemsSlice";
import randomQuoteSliceReducer from "./slice/randomQuoteSlice";
import groceryListSlice from "./slice/groceryListSlice";
import recipeSlice from "./slice/recipeSlice";
import measurementSlice from "./slice/measurementSlice";
import ingredientsSlice from "./slice/ingredientsSlice";
import tmdbTVShowSlice from "./slice/tmdbTVShowSlice";
import tvShowSlice from "./slice/tvShowSlice";
import tvShowGenreSlice from "./slice/tvShowGenreSlice";
import tvShowLanguageSlice from "./slice/tvShowLanguageSlice";
import googleBookReducer from "./slice/googleBookSlice";
import googlePlacesSlice from "./slice/googlePlacesSlice";
import restaurantSlice from "./slice/restaurantSlice";
import restaurantListsSlice from "./slice/restaurantListsSlice";
import restaurantListItemsSlice from "./slice/restaurantListItemsSlice";

export const store = configureStore({
  reducer: {
    books: bookReducer,
    authors: authorReducer,
    ratings: ratingReducer,
    tvShowLists: tvShowListReducer,
    tvShowListItems: tvShowListItemReducer,
    randomQuote: randomQuoteSliceReducer,
    groceryList: groceryListSlice,
    recipes: recipeSlice,
    measurements: measurementSlice,
    ingredients: ingredientsSlice,
    tmdbTVShows: tmdbTVShowSlice,
    tvShows: tvShowSlice,
    tvShowGenres: tvShowGenreSlice,
    tvShowLanguages: tvShowLanguageSlice,
    googleBooks: googleBookReducer,
    googlePlaces: googlePlacesSlice,
    restaurants: restaurantSlice,
    restaurantLists: restaurantListsSlice,
    restaurantListItems: restaurantListItemsSlice,
  },
});
